export default __webpack_public_path__ + "static/media/logo-m.074ef300.svg";